import { render, staticRenderFns } from "./AlibiTrackOrderBlock.vue?vue&type=template&id=09ff7448"
import script from "./AlibiTrackOrderBlock.vue?vue&type=script&lang=js"
export * from "./AlibiTrackOrderBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports